import {
  withFormsy,
} from 'formsy-react';
import {
  withTranslation,
} from 'react-i18next';

import InputRegattaGroupView from './InputRegattaGroupView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputRegattaGroupView);

const TranslatedComponent = withTranslation()(InputComponent);

const Component = TranslatedComponent;

export default Component;
